import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45;

import { computed, makeObservable, observable, runInAction } from "mobx";
import { formatPhoneNumber, normalizePhoneNumber } from "@dp/common";
import * as yup from "yup";
import moment from "moment";
import reverse from "lodash/reverse";
import isEqual from "lodash/isEqual";
import BrandRules from "../../utils/BrandRules";
export var ReservationSelectedCTA;

(function (ReservationSelectedCTA) {
  ReservationSelectedCTA[ReservationSelectedCTA["DATE"] = 0] = "DATE";
  ReservationSelectedCTA[ReservationSelectedCTA["GUESTS"] = 1] = "GUESTS";
  ReservationSelectedCTA[ReservationSelectedCTA["PREFFERED_TIME"] = 2] = "PREFFERED_TIME";
  ReservationSelectedCTA[ReservationSelectedCTA["AVAILBALE_SLOTS"] = 3] = "AVAILBALE_SLOTS";
  ReservationSelectedCTA[ReservationSelectedCTA["DOB"] = 4] = "DOB";
  ReservationSelectedCTA[ReservationSelectedCTA["SPECIAL_REQUESTS"] = 5] = "SPECIAL_REQUESTS";
  ReservationSelectedCTA[ReservationSelectedCTA["MAX_GUESTS"] = 6] = "MAX_GUESTS";
  ReservationSelectedCTA[ReservationSelectedCTA["SEATING_OPTION"] = 7] = "SEATING_OPTION";
})(ReservationSelectedCTA || (ReservationSelectedCTA = {}));

export var ReservationBoxRefs;

(function (ReservationBoxRefs) {
  ReservationBoxRefs["PROFILE_CARD_REF"] = "PROFILE_CARD_REF";
  ReservationBoxRefs["RESERVATION_TIME_REF"] = "RESERVATION_TIME_REF";
  ReservationBoxRefs["RESERVATION_SEATING_OPTION_REF"] = "RESERVATION_SEATING_OPTION_REF";
})(ReservationBoxRefs || (ReservationBoxRefs = {}));

var phoneRegExp = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s-]?[\0-9]{3}[\s-]?[0-9]{4}$/;

var _SCHEMA = yup.object({
  firstName: yup.string().trim().min(2, "Min. 2 characters required").max(32, "Max. characters allowed are 32").required("This field is mandatory"),
  lastName: yup.string().trim().required("This field is mandatory"),
  email: yup.string().email("Please enter a valid email").required("Please enter a valid email"),
  noOfGuests: yup.number().required("This Field is mandatory").moreThan(0).test("len", "Please Enter your Party-size", function (val) {
    return val > 0;
  }),
  phoneNumber: yup.string().matches(phoneRegExp, "Phone number is not valid").required("This field is mandatory"),
  reservationTime: yup.string().trim().required("This field is mandatory")
});

var ReservationModel = (_class = /*#__PURE__*/function () {
  function ReservationModel(platformUtil) {
    var _this = this;

    _classCallCheck(this, ReservationModel);

    _initializerDefineProperty(this, "_noOfGuests", _descriptor, this);

    _initializerDefineProperty(this, "_reservationDateinTimestamp", _descriptor2, this);

    _initializerDefineProperty(this, "_preferredTime", _descriptor3, this);

    _initializerDefineProperty(this, "_showSpecialRequests", _descriptor4, this);

    _initializerDefineProperty(this, "_specialRequestsText", _descriptor5, this);

    _initializerDefineProperty(this, "_reservationTypeIsBusiness", _descriptor6, this);

    _initializerDefineProperty(this, "_selectedSeatingOption", _descriptor7, this);

    _initializerDefineProperty(this, "_seatingOptions", _descriptor8, this);

    _initializerDefineProperty(this, "_restDetails", _descriptor9, this);

    _initializerDefineProperty(this, "_restTimeSlotsResp", _descriptor10, this);

    _initializerDefineProperty(this, "_restAvailableSlotsResp", _descriptor11, this);

    _initializerDefineProperty(this, "_currentSelectedCTA", _descriptor12, this);

    _initializerDefineProperty(this, "_errObj", _descriptor13, this);

    _initializerDefineProperty(this, "_firstName", _descriptor14, this);

    _initializerDefineProperty(this, "_lastName", _descriptor15, this);

    _initializerDefineProperty(this, "_email", _descriptor16, this);

    _initializerDefineProperty(this, "_phoneNumber", _descriptor17, this);

    _initializerDefineProperty(this, "_dob", _descriptor18, this);

    _initializerDefineProperty(this, "_isFirstTime", _descriptor19, this);

    _initializerDefineProperty(this, "_isFirstTimeAtLocation", _descriptor20, this);

    _initializerDefineProperty(this, "_reservationTime", _descriptor21, this);

    _initializerDefineProperty(this, "_eclubOption", _descriptor22, this);

    _initializerDefineProperty(this, "_secondarySub", _descriptor23, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor24, this);

    _initializerDefineProperty(this, "_errorsYPosition", _descriptor25, this);

    _initializerDefineProperty(this, "_showTimePicker", _descriptor26, this);

    _initializerDefineProperty(this, "_confirmationNumber", _descriptor27, this);

    _initializerDefineProperty(this, "_activeReservations", _descriptor28, this);

    _initializerDefineProperty(this, "_notificationID", _descriptor29, this);

    _initializerDefineProperty(this, "_pastReservations", _descriptor30, this);

    _initializerDefineProperty(this, "_secondarySubscriptions", _descriptor31, this);

    _initializerDefineProperty(this, "_reviewReservationsEmail", _descriptor32, this);

    _initializerDefineProperty(this, "_isChangeLocationModalOpen", _descriptor33, this);

    _initializerDefineProperty(this, "_selectedLocationState", _descriptor34, this);

    _initializerDefineProperty(this, "_isLocationsListLoading", _descriptor35, this);

    _initializerDefineProperty(this, "_isReservationLoading", _descriptor36, this);

    _initializerDefineProperty(this, "_locationsList", _descriptor37, this);

    _initializerDefineProperty(this, "_restAvailableSlotsError", _descriptor38, this);

    _initializerDefineProperty(this, "_lookupReservationErrorResp", _descriptor39, this);

    _initializerDefineProperty(this, "_isReserveTableWebTabActive", _descriptor40, this);

    _initializerDefineProperty(this, "_reservationContainerRefs", _descriptor41, this);

    _initializerDefineProperty(this, "_isRestAvailableSlotsLoading", _descriptor42, this);

    _initializerDefineProperty(this, "_pdfMenuUrl", _descriptor43, this);

    _initializerDefineProperty(this, "_detailsClone", _descriptor44, this);

    _initializerDefineProperty(this, "_reservationCancelSuccessModal", _descriptor45, this);

    _defineProperty(this, "platformUtil", void 0);

    _defineProperty(this, "setErrorsYPosition", function (key, yPosition) {
      runInAction(function () {
        _this._errorsYPosition[key] = yPosition;
      });
    });

    this.platformUtil = platformUtil;
    makeObservable(this);
  }

  _createClass(ReservationModel, [{
    key: "setAttributes",
    value: function setAttributes(_appAttributes) {
      var _this2 = this;

      runInAction(function () {
        _this2._appAttributes = _appAttributes;
        _this2.preferredTime = _appAttributes === null || _appAttributes === void 0 ? void 0 : _appAttributes.reservationDefaultTime;
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this3 = this;

      runInAction(function () {
        _this3._noOfGuests = "";
        _this3._reservationDateinTimestamp = moment().toDate() + "";
        _this3._preferredTime = "";
        _this3._showSpecialRequests = false;
        _this3._specialRequestsText = "";
        _this3._reservationTypeIsBusiness = null;
        _this3._selectedSeatingOption = "";
        _this3._restTimeSlotsResp = null;
        _this3._restAvailableSlotsResp = null;
        _this3._currentSelectedCTA = ReservationSelectedCTA.AVAILBALE_SLOTS;
        _this3._errObj = null;
        _this3._firstName = "";
        _this3._lastName = "";
        _this3._email = "";
        _this3._phoneNumber = "";
        _this3._dob = null;
        _this3._isFirstTime = false;
        _this3._isFirstTimeAtLocation = false;
        _this3._reservationTime = "";
        _this3._eclubOption = false;
        _this3._secondarySub = false;
        _this3._errorsYPosition = {};
        _this3._showTimePicker = false;
        _this3._confirmationNumber = "";
      });
    }
  }, {
    key: "updatevalues",
    value: function updatevalues(obj) {
      var _obj$details, _obj$details2, _obj$details3, _obj$details4, _obj$userDetail, _obj$userDetail2, _obj$userDetail3, _obj$userDetail3$phon, _obj$userDetail4, _obj$eventInfo, _obj$eventInfo2, _obj$eventInfo2$speci, _obj$eventInfo3, _obj$eventInfo4, _obj$eventInfo5;

      this.restAvailableSlotsError = "";
      this.seatingOptions = [];
      this.selectedSeatingOption = "";
      this.reservationTime = "";
      this.restDetails = obj === null || obj === void 0 ? void 0 : obj.restaurantDetail;
      this.reservationDateinTimestamp = moment(obj === null || obj === void 0 ? void 0 : (_obj$details = obj.details) === null || _obj$details === void 0 ? void 0 : _obj$details.date, "YYYY-MM-DD").format();
      this.noOfGuests = "" + ((_obj$details2 = obj.details) === null || _obj$details2 === void 0 ? void 0 : _obj$details2.partySize);
      this.reservationTime = moment(obj === null || obj === void 0 ? void 0 : (_obj$details3 = obj.details) === null || _obj$details3 === void 0 ? void 0 : _obj$details3.time, "hh:mm A").format("HH:mm:ss");
      this.preferredTime = obj === null || obj === void 0 ? void 0 : (_obj$details4 = obj.details) === null || _obj$details4 === void 0 ? void 0 : _obj$details4.time;
      this.selectedSeatingOption = obj === null || obj === void 0 ? void 0 : obj.seatingType;
      this.firstName = obj === null || obj === void 0 ? void 0 : (_obj$userDetail = obj.userDetail) === null || _obj$userDetail === void 0 ? void 0 : _obj$userDetail.firstName;
      this.lastName = obj === null || obj === void 0 ? void 0 : (_obj$userDetail2 = obj.userDetail) === null || _obj$userDetail2 === void 0 ? void 0 : _obj$userDetail2.lastName;
      this.confirmationNumber = obj === null || obj === void 0 ? void 0 : obj.confirmationNumber;
      var val = (_obj$userDetail3 = obj.userDetail) === null || _obj$userDetail3 === void 0 ? void 0 : (_obj$userDetail3$phon = _obj$userDetail3.phone) === null || _obj$userDetail3$phon === void 0 ? void 0 : _obj$userDetail3$phon.replace(/[^\d]/g, "");
      this.phoneNumber = normalizePhoneNumber(val, this.phoneNumber);
      this.email = obj === null || obj === void 0 ? void 0 : (_obj$userDetail4 = obj.userDetail) === null || _obj$userDetail4 === void 0 ? void 0 : _obj$userDetail4.email;
      this.specialRequestsText = (_obj$eventInfo = obj.eventInfo) === null || _obj$eventInfo === void 0 ? void 0 : _obj$eventInfo.specialRequests;

      if (((_obj$eventInfo2 = obj.eventInfo) === null || _obj$eventInfo2 === void 0 ? void 0 : (_obj$eventInfo2$speci = _obj$eventInfo2.specialRequests) === null || _obj$eventInfo2$speci === void 0 ? void 0 : _obj$eventInfo2$speci.length) > 0) {
        this.showSpecialRequests = true;
      }

      this.isFirstTime = obj === null || obj === void 0 ? void 0 : (_obj$eventInfo3 = obj.eventInfo) === null || _obj$eventInfo3 === void 0 ? void 0 : _obj$eventInfo3.isFirstTime;
      this.isFirstTimeAtLocation = obj === null || obj === void 0 ? void 0 : (_obj$eventInfo4 = obj.eventInfo) === null || _obj$eventInfo4 === void 0 ? void 0 : _obj$eventInfo4.isFirstTimeAtLocation;
      this.reservationTypeIsBusiness = obj === null || obj === void 0 ? void 0 : (_obj$eventInfo5 = obj.eventInfo) === null || _obj$eventInfo5 === void 0 ? void 0 : _obj$eventInfo5.isBusiness; // this.dob = obj.userDetail?.dob || "";
    }
  }, {
    key: "setDetailsClone",
    value: function setDetailsClone() {
      var _this4 = this;

      runInAction(function () {
        _this4._detailsClone = {
          firstName: _this4.firstName,
          lastName: _this4.lastName,
          email: _this4.email,
          phoneNumber: _this4.phoneNumber,
          noOfGuests: _this4.noOfGuests,
          reservationTime: _this4.reservationTime,
          reservationDateinTimestamp: _this4.reservationDateinTimestamp,
          secondarySubscriptions: _this4.secondarySubscriptions,
          dob: _this4.dob,
          specialRequestsText: _this4.specialRequestsText,
          seatingType: _this4.selectedSeatingOption,
          reservationType: _this4.reservationTypeIsBusiness
        };
      });
    }
  }, {
    key: "getRestaurantPhoneNumberByTypeModel",
    value: function getRestaurantPhoneNumberByTypeModel(phoneNumbers, type) {
      if (phoneNumbers && phoneNumbers.length > 0) {
        var res = phoneNumbers.filter(function (phoneNumber) {
          return phoneNumber.type === type;
        });
        return res.length > 0 ? res[0] : null;
      } else {
        return null;
      }
    }
  }, {
    key: "getRestContactInfo",
    value: function getRestContactInfo() {
      var _this$restDetails, _this$restDetails$con;

      var restPhoneNumbers = this === null || this === void 0 ? void 0 : (_this$restDetails = this.restDetails) === null || _this$restDetails === void 0 ? void 0 : (_this$restDetails$con = _this$restDetails.contactDetail) === null || _this$restDetails$con === void 0 ? void 0 : _this$restDetails$con.phoneDetail;
      var primary = this.getRestaurantPhoneNumberByTypeModel(restPhoneNumbers, "Primary");

      if (primary) {
        return formatPhoneNumber(primary === null || primary === void 0 ? void 0 : primary.phoneNumber);
      } else {
        var second = this.getRestaurantPhoneNumberByTypeModel(restPhoneNumbers, "Secondary");

        if (second) {
          return formatPhoneNumber(second === null || second === void 0 ? void 0 : second.phoneNumber);
        } else {
          var third = this.getRestaurantPhoneNumberByTypeModel(restPhoneNumbers, "Third");

          if (third) {
            return formatPhoneNumber(third === null || third === void 0 ? void 0 : third.phoneNumber);
          }
        }
      }

      return "";
    }
  }, {
    key: "reservationDateinTimestamp",
    set: function set(reservationDate) {
      var _this5 = this;

      runInAction(function () {
        _this5._reservationDateinTimestamp = reservationDate;
      });
    },
    get: function get() {
      return this._reservationDateinTimestamp;
    }
  }, {
    key: "noOfGuests",
    set: function set(noOfGuests) {
      var _this6 = this;

      runInAction(function () {
        _this6._noOfGuests = noOfGuests;
      });
    },
    get: function get() {
      return this._noOfGuests;
    }
  }, {
    key: "preferredTime",
    set: function set(preferredTime) {
      var _this7 = this;

      runInAction(function () {
        _this7._preferredTime = preferredTime;
      });
    },
    get: function get() {
      return this._preferredTime;
    }
  }, {
    key: "showSpecialRequests",
    set: function set(showSpecialRequests) {
      var _this8 = this;

      runInAction(function () {
        _this8._showSpecialRequests = showSpecialRequests;
      });
    },
    get: function get() {
      return this._showSpecialRequests;
    }
  }, {
    key: "specialRequestsText",
    set: function set(specialRequestsText) {
      var _this9 = this;

      runInAction(function () {
        _this9._specialRequestsText = specialRequestsText;
      });
    },
    get: function get() {
      return this._specialRequestsText;
    }
  }, {
    key: "reservationTypeIsBusiness",
    set: function set(reservationType) {
      var _this10 = this;

      runInAction(function () {
        _this10._reservationTypeIsBusiness = reservationType;
      });
    },
    get: function get() {
      return this._reservationTypeIsBusiness;
    }
  }, {
    key: "selectedSeatingOption",
    set: function set(selectedSeatingOption) {
      var _this11 = this;

      runInAction(function () {
        _this11._selectedSeatingOption = selectedSeatingOption;
      });
    },
    get: function get() {
      return this._selectedSeatingOption;
    }
  }, {
    key: "seatingOptions",
    set: function set(_seatingOptions) {
      var _this12 = this;

      runInAction(function () {
        _this12._seatingOptions = _seatingOptions;
      });
    },
    get: function get() {
      return this._seatingOptions;
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "reviewReservationsEmail",
    set: function set(email) {
      var _this13 = this;

      runInAction(function () {
        _this13._reviewReservationsEmail = email;
      });
    },
    get: function get() {
      return this._reviewReservationsEmail;
    }
  }, {
    key: "isChangeLocationModalOpen",
    get: function get() {
      return this._isChangeLocationModalOpen;
    },
    set: function set(value) {
      var _this14 = this;

      runInAction(function () {
        _this14._isChangeLocationModalOpen = value;
      });
    }
  }, {
    key: "selectedLocationState",
    set: function set(value) {
      var _this15 = this;

      runInAction(function () {
        _this15._selectedLocationState = value;
      });
    },
    get: function get() {
      return this._selectedLocationState;
    }
  }, {
    key: "isLocationsListLoading",
    get: function get() {
      return this._isLocationsListLoading;
    },
    set: function set(value) {
      var _this16 = this;

      runInAction(function () {
        _this16._isLocationsListLoading = value;
      });
    }
  }, {
    key: "isReservationLoading",
    get: function get() {
      return this._isReservationLoading;
    },
    set: function set(value) {
      var _this17 = this;

      runInAction(function () {
        _this17._isReservationLoading = value;
      });
    }
  }, {
    key: "allReservationsStates",
    get: function get() {
      var _this$_locationsList, _this$_locationsList$;

      return Array.from(new Set((_this$_locationsList = this._locationsList) === null || _this$_locationsList === void 0 ? void 0 : (_this$_locationsList$ = _this$_locationsList.map(function (item) {
        var _item$contactDetail, _item$contactDetail$a;

        var stateName = item === null || item === void 0 ? void 0 : (_item$contactDetail = item.contactDetail) === null || _item$contactDetail === void 0 ? void 0 : (_item$contactDetail$a = _item$contactDetail.address) === null || _item$contactDetail$a === void 0 ? void 0 : _item$contactDetail$a.stateName;
        return stateName;
      })) === null || _this$_locationsList$ === void 0 ? void 0 : _this$_locationsList$.sort()));
    }
  }, {
    key: "sortedReservationLocations",
    get: function get() {
      var _this18 = this;

      var sortedStates = this._selectedLocationState !== "all" ? [this._selectedLocationState] : this.allReservationsStates;
      var reservationLocationList = sortedStates === null || sortedStates === void 0 ? void 0 : sortedStates.map(function (state) {
        var _this18$_locationsLis;

        var locationArray = _this18 === null || _this18 === void 0 ? void 0 : (_this18$_locationsLis = _this18._locationsList) === null || _this18$_locationsLis === void 0 ? void 0 : _this18$_locationsLis.filter(function (location) {
          var _location$contactDeta, _location$contactDeta2, _location$contactDeta3;

          return (location === null || location === void 0 ? void 0 : (_location$contactDeta = location.contactDetail) === null || _location$contactDeta === void 0 ? void 0 : (_location$contactDeta2 = _location$contactDeta.address) === null || _location$contactDeta2 === void 0 ? void 0 : (_location$contactDeta3 = _location$contactDeta2.stateName) === null || _location$contactDeta3 === void 0 ? void 0 : _location$contactDeta3.toLowerCase()) === (state === null || state === void 0 ? void 0 : state.toLowerCase());
        });
        return {
          stateName: state,
          locations: locationArray
        };
      });
      return reservationLocationList;
    }
  }, {
    key: "locationsList",
    set: function set(value) {
      var _this19 = this;

      runInAction(function () {
        _this19._locationsList = value;
      });
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "restDetails",
    set: function set(restDetails) {
      var _this20 = this;

      runInAction(function () {
        _this20._restDetails = restDetails;
      });
    },
    get: function get() {
      return this._restDetails;
    }
  }, {
    key: "restTimeSlotsResp",
    set: function set(restTimeSlotsResp) {
      var _this21 = this;

      runInAction(function () {
        _this21._restTimeSlotsResp = restTimeSlotsResp;
      });
    },
    get: function get() {
      return this._restTimeSlotsResp;
    }
  }, {
    key: "currentSelectedCTA",
    set: function set(currentSelectedCTA) {
      var _this22 = this;

      runInAction(function () {
        _this22._currentSelectedCTA = currentSelectedCTA;
      });
    },
    get: function get() {
      return this._currentSelectedCTA;
    }
  }, {
    key: "availableSlots",
    get: function get() {
      var _this$_restTimeSlotsR, _this$_restTimeSlotsR2;

      var startTime = (_this$_restTimeSlotsR = this._restTimeSlotsResp) === null || _this$_restTimeSlotsR === void 0 ? void 0 : _this$_restTimeSlotsR.startTime;
      var endTime = (_this$_restTimeSlotsR2 = this._restTimeSlotsResp) === null || _this$_restTimeSlotsR2 === void 0 ? void 0 : _this$_restTimeSlotsR2.endTime;

      if (startTime && endTime) {
        var start = moment(startTime, "HH:mm A");
        var end = moment(endTime, "HH:mm A"); // setting start time to a multiple of 5

        start.minutes(Math.ceil(start.minutes() / 5) * 5);
        var result = [];
        var current = moment(start);

        while (current <= end) {
          result.push(current.format("h:mm A"));
          current.add(this._restTimeSlotsResp.interval || 15, "minutes");
        }

        return result;
      } else return [];
    }
  }, {
    key: "restAvailableSlotsResp",
    set: function set(restAvailableSlotsResp) {
      var _this23 = this;

      runInAction(function () {
        _this23._restAvailableSlotsResp = restAvailableSlotsResp;
      });
    },
    get: function get() {
      return this._restAvailableSlotsResp;
    }
  }, {
    key: "lookupReservationErrorResp",
    get: function get() {
      return this._lookupReservationErrorResp;
    },
    set: function set(_val) {
      var _this24 = this;

      runInAction(function () {
        _this24._lookupReservationErrorResp = _val;
      });
    }
  }, {
    key: "restAvailableSlotsError",
    set: function set(_val) {
      var _this25 = this;

      runInAction(function () {
        _this25._restAvailableSlotsError = _val;
      });
    },
    get: function get() {
      return this._restAvailableSlotsError;
    }
  }, {
    key: "errObj",
    get: function get() {
      return this._errObj;
    },
    set: function set(errObj) {
      var _this26 = this;

      runInAction(function () {
        _this26._errObj = errObj;
      });
    }
  }, {
    key: "firstName",
    get: function get() {
      return this._firstName;
    },
    set: function set(_firstName) {
      var _this27 = this;

      runInAction(function () {
        _this27._firstName = _firstName;
      });
    }
  }, {
    key: "lastName",
    get: function get() {
      return this._lastName;
    },
    set: function set(_lastName) {
      var _this28 = this;

      runInAction(function () {
        _this28._lastName = _lastName;
      });
    }
  }, {
    key: "tabReserveTable",
    get: function get() {
      return this._isReserveTableWebTabActive;
    },
    set: function set(val) {
      var _this29 = this;

      runInAction(function () {
        _this29._isReserveTableWebTabActive = val;
      });
    }
  }, {
    key: "email",
    get: function get() {
      return this._email;
    },
    set: function set(_email) {
      var _this30 = this;

      runInAction(function () {
        _this30._email = _email;
      });
    }
  }, {
    key: "phoneNumber",
    get: function get() {
      return this._phoneNumber;
    },
    set: function set(value) {
      var _this31 = this;

      var newVal = normalizePhoneNumber(value, this.phoneNumber);
      runInAction(function () {
        _this31._phoneNumber = newVal;
      });
    }
  }, {
    key: "dob",
    get: function get() {
      return this._dob;
    },
    set: function set(dob) {
      var _this32 = this;

      runInAction(function () {
        _this32._dob = dob;
      });
    }
  }, {
    key: "isFirstTime",
    get: function get() {
      return this._isFirstTime;
    },
    set: function set(isFirstTime) {
      var _this33 = this;

      runInAction(function () {
        _this33._isFirstTime = isFirstTime;
      });
    }
  }, {
    key: "isFirstTimeAtLocation",
    get: function get() {
      return this._isFirstTimeAtLocation;
    },
    set: function set(isFirstTimeAtLocation) {
      var _this34 = this;

      runInAction(function () {
        _this34._isFirstTimeAtLocation = isFirstTimeAtLocation;
      });
    }
  }, {
    key: "reservationTime",
    get: function get() {
      return this._reservationTime;
    },
    set: function set(reservationTime) {
      var _this35 = this;

      runInAction(function () {
        _this35._reservationTime = reservationTime;
      });
    }
  }, {
    key: "showReservationCancelSuccessModal",
    set: function set(_val) {
      this._reservationCancelSuccessModal = _val;
    },
    get: function get() {
      return this._reservationCancelSuccessModal;
    }
  }, {
    key: "eclubOption",
    get: function get() {
      return this._eclubOption;
    },
    set: function set(eclubOption) {
      var _this36 = this;

      runInAction(function () {
        _this36._eclubOption = eclubOption;
      });
    }
  }, {
    key: "secondarySub",
    get: function get() {
      return this._secondarySub;
    },
    set: function set(secondarySub) {
      var _this37 = this;

      runInAction(function () {
        _this37._secondarySub = secondarySub;
      });
    }
  }, {
    key: "isModelValid",
    get: function get() {
      var isValid = this.reservationDateinTimestamp && this.noOfGuests && this.reservationTime && this.firstName && this.lastName && this.email && this.phoneNumber;
      return isValid ? true : false;
    }
  }, {
    key: "errorsYPosition",
    get: function get() {
      return this._errorsYPosition;
    }
  }, {
    key: "showTimePicker",
    get: function get() {
      return this._showTimePicker;
    },
    set: function set(showTimePicker) {
      var _this38 = this;

      runInAction(function () {
        _this38._showTimePicker = showTimePicker;
      });
    }
  }, {
    key: "confirmationNumber",
    get: function get() {
      return this._confirmationNumber;
    },
    set: function set(confirmationNumber) {
      var _this39 = this;

      runInAction(function () {
        _this39._confirmationNumber = confirmationNumber;
      });
    }
  }, {
    key: "activeReservations",
    get: function get() {
      return reverse(this._activeReservations);
    },
    set: function set(activeReservations) {
      var _this40 = this;

      runInAction(function () {
        _this40._activeReservations = activeReservations;
      });
    }
  }, {
    key: "notificationID",
    get: function get() {
      return this._notificationID;
    },
    set: function set(notificationID) {
      var _this41 = this;

      runInAction(function () {
        _this41._notificationID = notificationID;
      });
    }
  }, {
    key: "pastReservations",
    get: function get() {
      return reverse(this._pastReservations);
    },
    set: function set(pastReservations) {
      var _this42 = this;

      runInAction(function () {
        _this42._pastReservations = pastReservations;
      });
    }
  }, {
    key: "secondarySignupSources",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$;

      var brandCode = {
        "general-og-Logo": "OG",
        "general-longhorn-logo": "LH",
        "general-cheddars-logo": "CS",
        "general-yard-logo": "YH",
        "general-bahama-breeze-logo": "BB",
        "general-capital-logo": "CG",
        "general-eddie-logo": "EV",
        "general-seasons-logo": "S52"
      };
      var sourcesString = (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$["orderconf-secondary-signup"];
      var sources = sourcesString === null || sourcesString === void 0 ? void 0 : sourcesString.split(",");

      if (sources) {
        return sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
          var _source, _brandNameRegex$exec;

          source = (_source = source) === null || _source === void 0 ? void 0 : _source.replace(/["']/g, "");
          var brandNameRegex = /general-(.*)-[lL]ogo/;
          var brandName = (_brandNameRegex$exec = brandNameRegex.exec(source)) === null || _brandNameRegex$exec === void 0 ? void 0 : _brandNameRegex$exec[1];
          return {
            clubName: brandCode[source],
            imageName: "".concat(brandName, "-club")
          };
        });
      }

      return [];
    }
  }, {
    key: "secondarySubscriptions",
    get: function get() {
      return this._secondarySubscriptions;
    },
    set: function set(data) {
      var _this43 = this;

      runInAction(function () {
        _this43._secondarySubscriptions = data;
      });
    }
  }, {
    key: "reservationContainerRefs",
    get: function get() {
      return this._reservationContainerRefs;
    },
    set: function set(_ref) {
      this._reservationContainerRefs = _ref;
    }
  }, {
    key: "disableReservation",
    get: function get() {
      return this._currentSelectedCTA === ReservationSelectedCTA.MAX_GUESTS || this.noOfGuests.includes("+");
    }
  }, {
    key: "isRestAvailableSlotsLoading",
    set: function set(_val) {
      this._isRestAvailableSlotsLoading = _val;
    },
    get: function get() {
      return this._isRestAvailableSlotsLoading;
    }
  }, {
    key: "showDefaultSeatingOptionsMessage",
    get: function get() {
      var _this$_appAttributes2;

      return new BrandRules((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : _this$_appAttributes2.currentConceptCode).showDefaultSeatingOptionsMessage();
    }
  }, {
    key: "showPDFMenu",
    get: function get() {
      var _this$_appAttributes3;

      return new BrandRules((_this$_appAttributes3 = this._appAttributes) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.currentConceptCode).showPDFMenu();
    }
  }, {
    key: "pdfMenuUrl",
    get: function get() {
      return this._pdfMenuUrl;
    },
    set: function set(url) {
      var _this44 = this;

      runInAction(function () {
        _this44._pdfMenuUrl = url;
      });
    }
  }, {
    key: "detailsClone",
    get: function get() {
      return this._detailsClone;
    }
  }, {
    key: "updateCTADisabled",
    get: function get() {
      var _this$detailsClone, _this$detailsClone2, _this$detailsClone3, _this$detailsClone4, _this$detailsClone5, _this$detailsClone6, _this$detailsClone7, _this$detailsClone8, _this$detailsClone9, _this$detailsClone10, _this$detailsClone11, _this$detailsClone12;

      var dataChanged = ((_this$detailsClone = this.detailsClone) === null || _this$detailsClone === void 0 ? void 0 : _this$detailsClone.firstName) !== this.firstName || ((_this$detailsClone2 = this.detailsClone) === null || _this$detailsClone2 === void 0 ? void 0 : _this$detailsClone2.lastName) !== this.lastName || ((_this$detailsClone3 = this.detailsClone) === null || _this$detailsClone3 === void 0 ? void 0 : _this$detailsClone3.email) !== this.email || ((_this$detailsClone4 = this.detailsClone) === null || _this$detailsClone4 === void 0 ? void 0 : _this$detailsClone4.phoneNumber) !== this.phoneNumber || ((_this$detailsClone5 = this.detailsClone) === null || _this$detailsClone5 === void 0 ? void 0 : _this$detailsClone5.noOfGuests) !== this.noOfGuests || ((_this$detailsClone6 = this.detailsClone) === null || _this$detailsClone6 === void 0 ? void 0 : _this$detailsClone6.reservationTime) !== this.reservationTime || ((_this$detailsClone7 = this.detailsClone) === null || _this$detailsClone7 === void 0 ? void 0 : _this$detailsClone7.reservationDateinTimestamp) !== this.reservationDateinTimestamp || ((_this$detailsClone8 = this.detailsClone) === null || _this$detailsClone8 === void 0 ? void 0 : _this$detailsClone8.dob) !== this.dob || ((_this$detailsClone9 = this.detailsClone) === null || _this$detailsClone9 === void 0 ? void 0 : _this$detailsClone9.specialRequestsText) !== this.specialRequestsText || ((_this$detailsClone10 = this.detailsClone) === null || _this$detailsClone10 === void 0 ? void 0 : _this$detailsClone10.seatingType) !== this.selectedSeatingOption || ((_this$detailsClone11 = this.detailsClone) === null || _this$detailsClone11 === void 0 ? void 0 : _this$detailsClone11.reservationType) !== this.reservationTypeIsBusiness;
      var subscriptionsChanged = isEqual((_this$detailsClone12 = this.detailsClone) === null || _this$detailsClone12 === void 0 ? void 0 : _this$detailsClone12.secondarySubscriptions, this.secondarySubscriptions);
      var ctaDisabled = !(dataChanged || !subscriptionsChanged);
      return ctaDisabled;
    }
  }, {
    key: "showAdditionalSeatingMsg",
    get: function get() {
      var slots = this.restAvailableSlotsResp;
      var show = false;
      slots === null || slots === void 0 ? void 0 : slots.forEach(function (slot) {
        var _slot$seatingTypes, _slot$seatingTypes2, _slot$seatingTypes3, _slot$seatingTypes4;

        if ((slot === null || slot === void 0 ? void 0 : (_slot$seatingTypes = slot.seatingTypes) === null || _slot$seatingTypes === void 0 ? void 0 : _slot$seatingTypes.length) > 1 || !(((_slot$seatingTypes2 = slot.seatingTypes) === null || _slot$seatingTypes2 === void 0 ? void 0 : _slot$seatingTypes2.length) === 1 && ((_slot$seatingTypes3 = slot.seatingTypes) !== null && _slot$seatingTypes3 !== void 0 && _slot$seatingTypes3.includes("STANDARD") || (_slot$seatingTypes4 = slot.seatingTypes) !== null && _slot$seatingTypes4 !== void 0 && _slot$seatingTypes4.includes("DEFAULT")))) show = true;
      });
      return show;
    }
  }, {
    key: "isSeatingTypeOnlyStandard",
    get: function get() {
      var slots = this.restAvailableSlotsResp;
      var show = false;
      slots === null || slots === void 0 ? void 0 : slots.forEach(function (slot) {
        var _slot$seatingTypes5, _slot$seatingTypes6;

        if ((slot === null || slot === void 0 ? void 0 : (_slot$seatingTypes5 = slot.seatingTypes) === null || _slot$seatingTypes5 === void 0 ? void 0 : _slot$seatingTypes5.length) === 1 && slot !== null && slot !== void 0 && (_slot$seatingTypes6 = slot.seatingTypes) !== null && _slot$seatingTypes6 !== void 0 && _slot$seatingTypes6.includes("STANDARD")) show = true;
      });
      return show;
    }
  }]);

  return ReservationModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_noOfGuests", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "" || "2";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_reservationDateinTimestamp", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return moment().toDate() + "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_preferredTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_showSpecialRequests", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_specialRequestsText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_reservationTypeIsBusiness", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_selectedSeatingOption", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_seatingOptions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_restDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_restTimeSlotsResp", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_restAvailableSlotsResp", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_currentSelectedCTA", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return ReservationSelectedCTA.AVAILBALE_SLOTS;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_errObj", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_firstName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_lastName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_email", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_phoneNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_dob", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_isFirstTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_isFirstTimeAtLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_reservationTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_eclubOption", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_secondarySub", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_errorsYPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_showTimePicker", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "_confirmationNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "_activeReservations", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "_notificationID", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "_pastReservations", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "_secondarySubscriptions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "_reviewReservationsEmail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "_isChangeLocationModalOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "_selectedLocationState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "all";
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "_isLocationsListLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "_isReservationLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "_locationsList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "_restAvailableSlotsError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "_lookupReservationErrorResp", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "_isReserveTableWebTabActive", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "_reservationContainerRefs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "_isRestAvailableSlotsLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "_pdfMenuUrl", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "_detailsClone", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      noOfGuests: "",
      reservationTime: "",
      reservationDateinTimestamp: "",
      secondarySubscriptions: "",
      dob: "",
      specialRequestsText: "",
      seatingType: "",
      reservationType: false
    };
  }
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "_reservationCancelSuccessModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      showModal: false,
      redirect: false,
      reload: false
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "reservationDateinTimestamp", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "reservationDateinTimestamp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noOfGuests", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "noOfGuests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preferredTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preferredTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSpecialRequests", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSpecialRequests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "specialRequestsText", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "specialRequestsText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reservationTypeIsBusiness", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "reservationTypeIsBusiness"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedSeatingOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedSeatingOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "seatingOptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "seatingOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewReservationsEmail", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewReservationsEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isChangeLocationModalOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isChangeLocationModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLocationsListLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLocationsListLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReservationLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReservationLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allReservationsStates", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allReservationsStates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortedReservationLocations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortedReservationLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restTimeSlotsResp", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restTimeSlotsResp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentSelectedCTA", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentSelectedCTA"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "availableSlots", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableSlots"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restAvailableSlotsResp", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restAvailableSlotsResp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lookupReservationErrorResp", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lookupReservationErrorResp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restAvailableSlotsError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restAvailableSlotsError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errObj", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errObj"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tabReserveTable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tabReserveTable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "email", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "email"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "phoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dob", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dob"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFirstTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFirstTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFirstTimeAtLocation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFirstTimeAtLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reservationTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "reservationTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showReservationCancelSuccessModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showReservationCancelSuccessModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eclubOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eclubOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySub", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySub"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isModelValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isModelValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorsYPosition", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorsYPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTimePicker", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showTimePicker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmationNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "confirmationNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeReservations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeReservations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "notificationID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "notificationID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pastReservations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pastReservations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySignupSources", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySignupSources"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySubscriptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySubscriptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reservationContainerRefs", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "reservationContainerRefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableReservation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableReservation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isRestAvailableSlotsLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isRestAvailableSlotsLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDefaultSeatingOptionsMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDefaultSeatingOptionsMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPDFMenu", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPDFMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pdfMenuUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pdfMenuUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "detailsClone", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "detailsClone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCTADisabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "updateCTADisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAdditionalSeatingMsg", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showAdditionalSeatingMsg"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSeatingTypeOnlyStandard", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSeatingTypeOnlyStandard"), _class.prototype)), _class);
export { ReservationModel as default };